import amplitude from 'tools/amplitude';

import type {
  LogCampaignEventChrome,
  LogCampaignEventChromeParams,
  LogHasChromeExtensionParams,
} from './chromeBrowserBanner.analytic.model';

function logHasChromeExtension(params: LogHasChromeExtensionParams) {
  amplitude.logEvent('EVENT_HAS_CHROME_EXTENSION', {
    PARTNER_ID: params.partnerId,
    IS_INSTALLED: params.isInstalled,
    PWA_INSTALL_STATUS: params.pwaInstallStatus,
  });
}

function logEventChrome(
  params: Omit<LogCampaignEventChromeParams, 'MODAL_TYPE'>,
) {
  const data: LogCampaignEventChrome = {
    PARTNER_ID: params.partnerId,
    ACTION_TYPE: params.userAction,
    MODAL_TYPE: 'BANNER',
    TYPE: params.missingContent,
    TEST: 'none',
  };
  amplitude.logEvent('EVENT_CHROME', data);
}

export const chromeBrowserBannerAnalytic = {
  logHasChromeExtension,
  logEventChrome,
} as const;
